import { component } from 'picoapp';

export default component((node) => {
  /**
   * Functions
   */
  const init = () => {
    node.addEventListener('click', () => {
      window.GorgiasChat?.open();
    });
  };

  /**
   * Init
   */
  init();
});
